import type {ButtonsLayout} from 'Shared/model/Components';
import { detailsStyle } from 'Shared/backend/widgets/Section';
import { StoreProvider, useStore } from 'Shared/StoreProvider';
import { LabelOnLeftWrap, noteStyle } from 'Shared/forms/Wrap';
import { Checkbox } from 'Shared/forms/Inputs';
import { addItemAndOpen, StoreRepeater } from 'Shared/forms/StoreRepeater';
import { css } from '@emotion/css';
import { theme } from 'Shared/ThemeProvider';
import { AddButton } from 'Shared/backend/widgets/AddButton';
import { Show } from 'solid-js';


export function initButtons()
{
	return {layout:'buttons',align:'left'};
}
import { useLayout } from 'Shared/backend/LayoutProvider';
import { repeaterBarStyle } from 'Shared/backend/widgets/SectionList';


export function Buttons(P:ButtonsLayout)
{
	const addStyle = css(theme().button, {
		alignSelf: 'flex-start'
	});

	const subnavStyle = css({
		display: 'flex',
		gap: '2em',
		justifyContent: 'flex-start',

		'& > *': {
			flex: '0 1'
		}
	});

	const sw = useStore();
	const lo = useLayout();
	let repeaterNode!:HTMLElement;

	/* 
		Hacky test to see if we are a top-level component. 
		We only support sub navs for components used at the section level.
		Its difficult to juggle the vertical space around the nav and to support stickyness otherwise.
	*/
	const atTop = () => sw.location.length==2;

	return (
		<div class={detailsStyle()}>
			<Show when={lo.layout()}>
				<div class={noteStyle()}>
					Subnavs are only supported for top-level components.
				</div>

				<Show when={atTop()}>
					<div class={subnavStyle}>
						<LabelOnLeftWrap label='Use as subnav'>
							<Checkbox field='isNav' />
						</LabelOnLeftWrap>

						<Show when={P.isNav}>
							<LabelOnLeftWrap label='Sticky'>
								<Checkbox field='sticky' />
							</LabelOnLeftWrap>
						</Show>
					</div>
				</Show>
			</Show>

			<StoreRepeater ref={repeaterNode} field='buttons' 
				renderTitle={i => 'Button' + (i.text ? ' • ' + i.text : '')}
				hideDelete={!lo.layout()}
				barStyle={repeaterBarStyle}
			>
				{(item,index) => 
					<StoreProvider {...sw} location={[...sw.location,'buttons',index]}>
						<AddButton {...P} />
					</StoreProvider>
				}
			</StoreRepeater>

			<Show when={lo.layout()}>
				<button class={addStyle} onClick={() => addItemAndOpen(sw,'buttons',repeaterNode,{openInSameWindow:true})}>
					<i class='fas fa-plus'/> Add button
				</button>
			</Show>
		</div>
	);
}

